// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1-s1a","selected":"Chip_selected__3LdL8"};